import { ensureRouteData } from '@/app/query-client'
import { certificatesQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/courses/certificates` loader.
 *
 * MAIN: issued certificates and the courses close to one — one payload, no
 * search params, read with suspense.
 */
export async function loadCertificates({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await ensureRouteData(queryClient, certificatesQueryOptions())
}
